<!--
 - Order filters component (order-filters.component.html).
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2022-2024 Build Centrix
 -->
<bc-templates-modal-layout
  [isLoading]="false"
  [loadingText]="('actions.loading'|translate)"
  (onCloseButtonClicked)="onDismiss()"
>
  <!--Dialog Title-->
  <div title-content>
    {{'order.filters.title.plural'|translate}}
  </div>
  <!--Dialog Content-->
  <div body-content>
    <div class="row">
      <div class="col-sm-4">
        <!--Order Types-->
        <bc-atoms-input-group
          labelIcon="all"
          labelTitle="{{'order.filters.order.types.title.plural'|translate}}"
          labelDescription="{{'order.filters.order.types.title.description'|translate}}"
          *ngIf="(filters | async)?.seatTypes?.length > 0"
        >
          <div
            class="item"
            *ngFor="let orderType of (filters | async)?.seatTypes"
          >
            <bc-atoms-checkbox
              [label]="orderType.label"
              [title]="orderType.label"
              [(model)]="orderType.selected"
              (onCheckboxClicked)="filtersChanged()"
            ></bc-atoms-checkbox>
          </div>
        </bc-atoms-input-group>
        <!--Order Statuses-->
        <bc-atoms-input-group
          labelIcon="all"
          labelTitle="{{'order.filters.statuses.orders.title.plural'|translate}}"
          labelDescription="{{'order.filters.statuses.orders.description'|translate}}"
          *ngIf="(filters | async)?.orderStatuses?.length > 0"
        >
          <div
            class="item"
            *ngFor="let orderStatus of (filters | async)?.orderStatuses"
          >
            <bc-atoms-checkbox
              [label]="orderStatus.label"
              [title]="orderStatus.label"
              [(model)]="orderStatus.selected"
              (onCheckboxClicked)="filtersChanged()"
            ></bc-atoms-checkbox>
          </div>
        </bc-atoms-input-group>
        <!--User Groups-->
        <bc-atoms-input-group
          labelIcon="userGroup"
          labelTitle="{{'order.filters.groups.user.title.plural'|translate}}"
          labelDescription="{{'order.filters.groups.user.description'|translate}}"
          *ngIf="(filters | async)?.userGroups?.length > 0"
        >
          <div
            class="item"
            *ngFor="let userGroup of (filters | async)?.userGroups"
          >
            <bc-atoms-checkbox
              [label]="userGroup.label"
              [title]="userGroup.label"
              [(model)]="userGroup.selected"
              (onCheckboxClicked)="filtersChanged()"
            ></bc-atoms-checkbox>
          </div>
        </bc-atoms-input-group>
      </div>
      <div class="col-sm-4">
        <!--Production Statuses-->
        <bc-atoms-input-group
          labelIcon="all"
          labelTitle="{{'order.filters.statuses.production.title.plural'|translate}}"
          labelDescription="{{'order.filters.statuses.production.description'|translate}}"
          *ngIf="(filters | async)?.productionStatuses?.length > 0"
        >
          <div
            class="item"
            *ngFor="let productionStatus of (filters | async)?.productionStatuses"
          >
            <bc-atoms-checkbox
              [label]="productionStatus.code"
              [title]="productionStatus.code"
              [(model)]="productionStatus.selected"
              (onCheckboxClicked)="filtersChanged()"
            ></bc-atoms-checkbox>
          </div>
        </bc-atoms-input-group>
        <!--Delivery Statuses-->
        <bc-atoms-input-group
          labelIcon="all"
          labelTitle="{{'order.filters.statuses.delivery.title.plural'|translate}}"
          labelDescription="{{'order.filters.statuses.delivery.description'|translate}}"
          *ngIf="(filters | async)?.deliveryStatuses?.length > 0"
        >
          <div
            class="item"
            *ngFor="let deliveryStatus of (filters | async)?.deliveryStatuses"
          >
            <bc-atoms-checkbox
              [label]="deliveryStatus.label"
              [title]="deliveryStatus.label"
              [(model)]="deliveryStatus.selected"
              (onCheckboxClicked)="filtersChanged()"
            ></bc-atoms-checkbox>
          </div>
        </bc-atoms-input-group>
      </div>
      <div class="col-sm-4">
        <!--Fulfillment Groups-->
        <bc-atoms-input-group
          labelIcon="userGroup"
          labelTitle="{{'order.filters.groups.fulfillment.title.plural'|translate}}"
          labelDescription="{{'order.filters.groups.fulfillment.description'|translate}}"
          *ngIf="(filters | async)?.fulfillmentGroups?.length > 0"
        >
          <div
            class="item"
            *ngFor="let fulfillmentGroup of (filters | async)?.fulfillmentGroups"
          >
            <bc-atoms-checkbox
              [label]="fulfillmentGroup.label"
              [title]="fulfillmentGroup.label"
              [(model)]="fulfillmentGroup.selected"
              (onCheckboxClicked)="filtersChanged()"
            ></bc-atoms-checkbox>
          </div>
        </bc-atoms-input-group>
        <!--Order Shipping Types-->
        <bc-atoms-input-group
          labelIcon="shipped"
          labelTitle="{{'order.filters.shipping.types.title.plural'|translate}}"
          labelDescription="{{'order.filters.shipping.types.description'|translate}}"
          *ngIf="(filters | async)?.orderShippingTypes?.length > 0"
        >
          <div
            class="item"
            *ngFor="let shippingType of (filters | async)?.orderShippingTypes"
          >
            <bc-atoms-checkbox
              [label]="shippingType.label"
              [title]="shippingType.label"
              [(model)]="shippingType.selected"
              (onCheckboxClicked)="filtersChanged()"
            ></bc-atoms-checkbox>
          </div>
        </bc-atoms-input-group>
      </div>
    </div>
  </div>
  <!--Dialog Actions-->
  <div footer-content>
    <div class="buttons-container">
      <div class="right-buttons">
        <!--Cancel/Close -->
        <bc-atoms-button
          [label]="('actions.close'|translate)"
          [title]="('actions.close'|translate)"
          type="default"
          icon="close"
          display="block"
          size="small"
          (onButtonClicked)="onDismiss()"
        >
        </bc-atoms-button>
      </div>
    </div>
  </div>
</bc-templates-modal-layout>
